import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, ViewChild } from "@angular/core";
import { BaseModalComponent } from "@ha/ui/common";
import { Select, Store } from "@ngxs/store";

import { SubscriptionInvitation, SubscriptionInvitationType } from "../../models/subscription-invitation";
import { SubscriptionsActions } from "../../states/subscriptions.actions";
import { NgSignaturePadOptions, SignaturePadComponent } from "@almothafar/angular-signature-pad";
import { AccountUser, CurrentAccountSelectors } from "@ha/feature/auth";
import { Observable } from "rxjs";

export interface SubscriptionInviteAnswerComponentData {
    invitation: SubscriptionInvitation;
}

@Component({
    templateUrl: "./subscription-invitation-answer.component.html",
    styleUrls: ["./subscription-invitation-answer.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubscriptionInvitationAnswerComponent extends BaseModalComponent {
    @ViewChild("signature")
    public signaturePad: SignaturePadComponent;

    public data!: SubscriptionInviteAnswerComponentData;
    
    @Select(CurrentAccountSelectors.currentAccountRealUser)
    public user$: Observable<AccountUser>;
    
    public signaturePadOptions: NgSignaturePadOptions = undefined;

    public hasSignature = false;

    public SubscriptionInvitationType = SubscriptionInvitationType;

    constructor(private store: Store,         
                private cdr: ChangeDetectorRef,
    ) {
       super();
    }

    public accept(): void {
        const currentPerson = this.store.selectSnapshot(CurrentAccountSelectors.currentAccount);
        this.store.dispatch(
            new SubscriptionsActions.AnswerInvitation(currentPerson.identityUserId, this.data.invitation, this.signaturePad.toDataURL(), true),
        );        
        this.closeModal();
    }

    public deny(): void {
        const currentPerson = this.store.selectSnapshot(CurrentAccountSelectors.currentAccount);
        this.store.dispatch(
            new SubscriptionsActions.AnswerInvitation(currentPerson.identityUserId, this.data.invitation, null, false),
        );        
        this.closeModal();
    }

    public ngAfterViewInit(): void {
        this.getScreenSize();
        this.signaturePad.clear(); // invoke functions from szimek/signature_pad API
    }

    @HostListener("window:resize", ["$event"])
        public getScreenSize() {
            let width = 400;
            if (window.innerWidth < width) {
                width = window.innerWidth;
            }
    
            this.signaturePadOptions = {
                minWidth: 1,
                maxWidth: 4,
                backgroundColor: "#ffffff",
                canvasWidth: width,
                canvasHeight: width / 2,
            };
    
            this.cdr.detectChanges();
        }
        
     // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public drawComplete(event: MouseEvent | Touch): void {
        this.hasSignature = !this.signaturePad.isEmpty();
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    public drawStart(event: MouseEvent | Touch): void {
    }

    public clear() {
        this.signaturePad.clear();
        this.hasSignature = !this.signaturePad.isEmpty();
    }
}
